export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ai-bank.a05af00e.svg","height":448,"width":1169,"blurWidth":0,"blurHeight":0};